import { AuthorizationTokenWithKeyPair } from "@ncino/pa-authentication-client-webclient";
import { AuthClient } from "@ncino/pa-authorization-client-webclient";
import { v4 as uuid } from "uuid";

let cachedPrincipalId: string | undefined;
let cachedResult: Promise<boolean> | undefined;

export async function hasRemittanceAccess(
  principalId: string,
  institutionId: number,
  tokenProvider: () => Promise<AuthorizationTokenWithKeyPair>,
  authClient: AuthClient
): Promise<boolean> {
  if (import.meta.env.DEV && localStorage.getItem("dev_remittanceAccess") === "true") {
    return true;
  }

  if (cachedResult && cachedPrincipalId === principalId) {
    return cachedResult;
  }
  const requests = [
    {
      principalType: "PAX::User",
      principalId,
      entityType: "PAX::MKT_INSTITUTION_GROUP",
      entityId: `mkt-inst:${institutionId}::viewRemittance`,
      actionType: "PAX::Action",
      actionId: "isInstitutionMember",
    },
    {
      principalType: "PAX::User",
      principalId,
      entityType: "PAX::MKT_INSTITUTION_GROUP",
      entityId: `mkt-inst:${institutionId}::approveRemittance`,
      actionType: "PAX::Action",
      actionId: "isInstitutionMember",
    },
  ];

  cachedPrincipalId = principalId;
  const result = authClient.assertAny(requests, {
    bearerTokenProvider: tokenProvider,
    correlationId: uuid(),
  });
  cachedResult = result;

  result.then(
    (allowed) => {
      if (import.meta.env.DEV) {
        console.log(
          "[remittanceAccess] principalId=%s institutionId=%d result=%s (viewRemittance OR approveRemittance on mkt-inst:%d)",
          principalId,
          institutionId,
          allowed ? "ALLOWED" : "DENIED",
          institutionId
        );
      }
    },
    () => {
      cachedResult = undefined;
      cachedPrincipalId = undefined;
    }
  );

  return result;
}
